
import { Shot } from '@/features/shotlist/store/useShotListStore'
import { db, ShotListEntity } from '@/shared/lib/db'

export const getShotListFromDB = async (projectId: string, sceneId: string): Promise<Shot[] | null> => {
    try {
        const result = await db.shotlists
            .where('[projectId+sceneId]')
            .equals([projectId, sceneId])
            .first()
        console.log('Fetched shot list from DB', { projectId, sceneId, },result)
        return result ? result.shots : null
    } catch (error) {
        console.error('Error fetching shot list from DB:', error)
        return null
    }
}

export const saveShotListToDB = async (projectId: string, sceneId: string, shots: Shot[]) => {
    try {
        const existing = await db.shotlists
            .where('[projectId+sceneId]')
            .equals([projectId, sceneId])
            .first()

        if (existing) {
            await db.shotlists.update(existing.id, {
                shots,
                updated_at: new Date()
            })
        } else {
            console.log('Adding new shotlist to DB', { projectId, sceneId, count: shots.length })
            
            const newEntry: ShotListEntity = {
                id: crypto.randomUUID(),
                projectId,
                sceneId,
                shots,
                created_at: new Date(),
                updated_at: new Date(),
            }
            await db.shotlists.add(newEntry)
        }
    } catch (error) {
        console.error('Error saving shot list to DB:', error)
        throw error
    }
}
